import React from 'react';
import { ResumeData } from '../../../types/resume';
import ContactForm from './steps/ContactForm';
import ExperienceForm from './steps/ExperienceForm';
import EducationForm from './steps/EducationForm';
import CertificationsForm from './steps/CertificationsForm';
import SkillsForm from './steps/SkillsForm';
import SummaryForm from './steps/SummaryForm';
import TemplateForm from './steps/TemplateForm';
import FinalizeForm from './steps/FinalizeForm';

interface Props {
  currentStep: string;
  data: ResumeData;
  onUpdate: (data: Partial<ResumeData>) => void;
}

export default function BuilderContent({ currentStep, data, onUpdate }: Props) {
  const components: Record<string, React.ComponentType<any>> = {
    contact: ContactForm,
    experience: ExperienceForm,
    education: EducationForm,
    certifications: CertificationsForm,
    skills: SkillsForm,
    summary: SummaryForm,
    template: TemplateForm,
    finalize: FinalizeForm
  };

  const StepComponent = components[currentStep];

  if (!StepComponent) {
    return <div>Invalid step</div>;
  }

  return (
    <div className="max-w-5xl mx-auto">
      <StepComponent data={data} onUpdate={onUpdate} />
    </div>
  );
}